<template>
  <div>
    <div>
      <div class="tlive-create__teacher--contain">
          <yxt-tooltip class="item"  effect="dark" :open-filter="true"  placement="top">
             <span class="tooltip">
                 <yxtbiz-user-name :name="value[0] && value[0].fullname || $t('pc_biz_notadded' /* 暂未添加 */)" />
             </span>
            <div slot='content'>
                <yxtbiz-user-name :name="value[0] && value[0].fullname || $t('pc_biz_notadded' /* 暂未添加 */)" />
            </div>
          </yxt-tooltip>
        <span class="tlive-create__teacher--choose" @click="showDialog">
            {{ $t('pc_biz_replaceLecturer' /* 更换讲师 */)}}
        </span>
      </div>
    </div>
     <!-- 选择学员 -->
      <yxt-drawer
        :before-close="onStudentBeforeClose"
        :header-border="false"
        :destroy-on-close="true"
        size="960px"
        :visible.sync="dialogVisible"
        v-loading="chooseLoading"
      >
        <yxt-user-selector
          ref="selector"
          :data="[]"
          :tabs="tabs"
          :function-code="isGroupOrg ? 'group_task_center' : 'tlive_mgmt_list'"
          :data-permission-code="
            isGroupOrg ? 'task_manage_platform' : 'tlive_mgmt_extent'
          "
          :enableGroupCorp="isGroupOrg"
        ></yxt-user-selector>
        <div slot="footer">
          <yxt-button @click="dialogVisible = false" plain>
            {{ $t('pc_biz_core_btn_cancel' /* 取消 */) }}
          </yxt-button>
          <yxt-button type="primary" @click="getTeacher('student')">
            {{ $t('pc_biz_core_btn_determine' /* 确认 */) }}
          </yxt-button>
        </div>
      </yxt-drawer>
  </div>
</template>
<script>
import CheckList from '../components/Scroll';

export default {
  name: 'LiveTeacher',
  inject: ['isGroupOrg'],
  props: {
    value: {
      type: Array,
      default: []
    }
  },
  components: {
    CheckList
  },
  data() {
    return {
      dialogVisible: false,
      tabs: ['persons', 'advance', 'import'],
      chooseLoading: false,
      maxCount: 1
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    onStudentBeforeClose(done) {
      done(false);
    },
    // 选人控件点确定
    getTeacher() {
      if (this.chooseLoading) {
        return;
      }
      let refs = this.$refs.selector;
      if (refs.processing) {
        this.$message.warning(
          this.$t('pc_biz_doing' /* 正在进行中，请稍后 */),
        );
        return;
      }
      refs.getSelected().then(result => {
        console.log('result', result);
        if (result.length === 0) {
          // 请选择需要添加的人员
          this.$alert(
            this.$t('pc_biz_chooseMember' /* 请选择需要添加的成员 */),
            this.$t('pc_biz_udp_lbl_closeTitle' /* 提示 */),
          );
          return;
        }
        if (
          this.maxCount &&
          result.length > this.maxCount
        ) {
          this.$alert(
            this.$t('pc_biz_onlyOneTeacher' /* 只能选取一位讲师 */),
            this.$t('pc_biz_udp_lbl_closeTitle' /* 提示 */),
          );
          return;
        }
        this.chooseLoading = true;
        this.selectTeacherCallback(result);
        this.dialogVisible = false;
        return;
      });
    },
    selectTeacherCallback(result) {
      let idNames = JSON.parse(JSON.stringify(result, ['id', 'fullname']));
      this.$emit('input', idNames);
      this.chooseLoading = false;
    }
  }
};
</script>
<style scoped lang="less"></style>
